import BaseApi from '@/api/controller/base';

const BUSINESS_API_URL = 'business/';

class BusinessApi extends BaseApi {
  constructor() {
    super(BUSINESS_API_URL);
  }

  get(id) {
    return this.api.get(`${id}`);
  }

  getReferrals(id) {
    return this.api.get(`${id}/referrals`);
  }

  upsert(business) {
    const businessId = business.id || '';
    return this.api.post(businessId, business);
  }

  getGridData(params) {
    return this.api.post('gridData', params);
  }

  getBusinesses() {
    return this.api.get('');
  }
}

const apiInstance = new BusinessApi();
export { BusinessApi, apiInstance };
export default apiInstance;
